export enum AnswerColor{
  Default,
  Red,
  Green,
  GreenWithTick
}
